import * as Yup from 'yup';

export function initialValues(permission) {
    return {
        entity: permission?.entity || "",
        address: permission?.address ||"",
        nameTechnicalContact: permission?.nameTechnicalContact || "",
        emailTechnicalContact: permission?.emailTechnicalContact || "",
        phoneTechnicalContact: permission?.phoneTechnicalContact || "",
        nameBussinesContact: permission?.nameBussinesContact || "",
        emailBussinesContact: permission?.emailBussinesContact || "",
        phoneBussinesContact: permission?.phoneBussinesContact || "",
        addressNode: permission?.addressNode || "",
        enode: permission?.enode || "",
        nameProject: permission?.nameProject || "",
        descriptionProject: permission?.descriptionProject || "",
        confidentiality: permission?.confidentiality || "",
        projectOnNode: permission?.projectOnNode || "",
        countries: permission?.countries || "",
        typeBeneficiaries: permission?.typeBeneficiaries || "",
        numberBeneficiaries: permission?.numberBeneficiaries || "",
        agree: permission?.agree || "",
        nameSignature: permission?.nameSignature || "",
        placeSignature: permission?.placeSignature || "",
        membership: permission?.membership || "",
        networkId: permission?.networkId || "648541",
        networkName: permission?.networkName || "Mainnet",
    };
}

export function validationSchema(permission) {
    return Yup.object({
        entity: Yup.string().required("Required"),
        address: Yup.string().required("Required"),
        nameTechnicalContact: Yup.string().required("Required"),
        emailTechnicalContact: Yup.string().email("Format email invalid").required("Required"),
        phoneTechnicalContact: Yup.string().required("Required"),
        nameBussinesContact: Yup.string().required("Required"),
        emailBussinesContact: Yup.string().email("Format email invalid").required("Required"),
        phoneBussinesContact: Yup.string().required("Required"),
       // addressNode: Yup.string().required("Required"),
        //enode:  Yup.string().required("Required"),
        nameProject: Yup.string().required("Required"),
        descriptionProject: Yup.string().required("Required"),
        confidentiality: Yup.string().required("Required"),
        projectOnNode: Yup.string().required("Required"),
        countries: Yup.string().required("Required"),
        typeBeneficiaries: Yup.string().required("Required"),
        numberBeneficiaries: Yup.string().required("Required"),
        agree: Yup.string().required("Required"),
        nameSignature: Yup.string().required("Required"),
        placeSignature: Yup.string().required("Required"),
    });
}